import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const NIVEL = { operador: 1, admin: 2, super_admin: 3 };

export default function PrivateRoute({ children, perfil }) {
  const { user, loading } = useAuth();

  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" replace />;

  if (perfil && NIVEL[user.perfil] < NIVEL[perfil]) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
